import React, { useCallback } from "react";
import { View, TouchableOpacity, StyleSheet } from "react-native";
import CallIcon from "@assets/svg/MyTasks/Call";
import WhatsappIcon from "@assets/svg/MyTasks/Whatsapp";
import ActionBtn from "./ActionBtn";

interface ContactAndActionBtnsProps {
  item: {
    user_name?: string;
    user_phone?: string;
    action?: string;
    action_at?: string;
    [key: string]: any; // If there are additional properties
  };
  onPressCall: (type: "phone" | "wa", item: any) => void;
  handlePressEditCallOptions: (item: any) => void;
  taskActionConfig: any;
  contactOpts: string[];
}

const CONTACT_OPTS: Record<string, string> = {
  DIALER: "DIALER",
  WA: "WA",
};

const ContactAndActionBtns: React.FC<ContactAndActionBtnsProps> = ({
  item,
  onPressCall,
  handlePressEditCallOptions,
  taskActionConfig,
  contactOpts,
}) => {
  const DialerBtn = useCallback(
    () => (
      <TouchableOpacity
        testID="mt-call-customer"
        onPress={() => onPressCall("phone", item)}
        style={styles.contactSectionContainer}
      >
        <View style={styles.btnContainer}>
          <CallIcon strokeColor="#2195F2" width={42} height={42} />
        </View>
      </TouchableOpacity>
    ),
    [onPressCall, item],
  );
  const WhatsappBtn = useCallback(
    () => (
      <TouchableOpacity
        testID="mt-whatsapp-customer"
        onPress={() => {
          onPressCall("wa", item);
        }}
        style={styles.contactSectionContainer}
      >
        <View style={styles.btnContainer}>
          <WhatsappIcon width={42} height={42} />
        </View>
      </TouchableOpacity>
    ),
    [onPressCall, item],
  );
  return (
    <View style={{ marginTop: 12, flexDirection: "row" }}>
      {contactOpts.map((btn) => {
        switch (btn) {
          case CONTACT_OPTS.DIALER:
            return <DialerBtn />;
          case CONTACT_OPTS.WA:
            return <WhatsappBtn />;
          default:
            return <DialerBtn />;
        }
      })}
      {item?.action ? (
        <ActionBtn
          onPress={() => handlePressEditCallOptions(item)}
          action={item?.action || ""}
          actionAt={item?.action_at || ""}
          taskActionConfig={taskActionConfig}
        />
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  contactSectionContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginRight: 16,
    height: "auto",
  },
  btnContainer: {
    backgroundColor: "#F5F5F5",
    padding: 8,
    borderRadius: 6,
    marginRight: 4,
  },
});

export default ContactAndActionBtns;
